import { Component, Input, SimpleChanges } from '@angular/core';
import { CategoryListResponse } from '@app-assets/models/assets.model';
import { Subject } from 'rxjs';
import { AssetsService } from '@app-assets/services/assets.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { HealthCheckGlossaryParam } from '@app-assets/models/assets.model';

@Component({
  selector: 'app-healthcheck-glossary',
  templateUrl: './healthcheck-glossary.component.html',
  styleUrls: ['./healthcheck-glossary.component.scss'],
})
export class HealthcheckGlossaryComponent {
  @Input() public selectedhealthEventId: string = '';

  public loader: boolean = true;
  @Input() private currentLang: string = 'en';
  @Input() private currentfleetIdSelected: string = '';
  public selectedHealthEventGuide: CategoryListResponse;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private assetService: AssetsService) {}

  ngOnInit(): void {
    if (this.selectedhealthEventId) {
      this.getCategoryList(this.currentLang.toLowerCase());
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selectedhealthEventId && changes.selectedhealthEventId && changes.selectedhealthEventId.currentValue) {
      this.getCategoryList(this.currentLang.toLowerCase());
    }
    if (this.selectedHealthEventGuide && changes.currentLang && changes.currentLang.currentValue) {
      this.currentLang = changes.currentLang.currentValue;
      this.getCategoryList(this.currentLang.toLowerCase());
    }
    if (this.currentfleetIdSelected && changes.fleetIdSelected && changes.fleetIdSelected.currentValue) {
      this.getCategoryList(this.currentLang.toLowerCase());
    }
  }

  private getCategoryList(currentLang: string) {
    this.loader = true;
    const params: HealthCheckGlossaryParam = {
      healthEventId: this.selectedhealthEventId,
    };

    if (currentLang) {
      params.language = currentLang;
    }
    this.assetService
      .getGlossaryOfDevice(params)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => (this.loader = false))
      )
      .subscribe(
        (res: CategoryListResponse) => {
          this.selectedHealthEventGuide = res;
          this.sortGuides();
        },
        () => {
          this.loader = false;
        }
      );
  }

  sortGuides() {
    if (Array.isArray(this.selectedHealthEventGuide.healthEventTroubleshootingGuides)) {
      this.selectedHealthEventGuide.healthEventTroubleshootingGuides.sort((a, b) => {
        if (a.guide === 'Definitions' && b.guide === 'Solutions') {
          return -1;
        } else if (a.guide === 'Solutions' && b.guide === 'Definitions') {
          return 1;
        }
        return 0;
      });
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
